const TimeInputStringRegExp = /^(?:0\d|1\d|2[0-3]):[0-5]\d(?::[0-5]\d)?$/;
function assertTimeString(value) {
  if (!(typeof value === "string" && value.match(TimeInputStringRegExp))) {
    throw new Error("Expecting time value in format `hh:mm` or `hh:mm:ss`, got " + JSON.stringify(value));
  }
}
const DateInputStringRegExp = /^\d+-(?:0\d|1[0-2])-(?:[0-2]\d|3[0-1])$/;
function assertDateString(value) {
  if (!(typeof value === "string" && value.match(DateInputStringRegExp))) {
    throw new Error("Expecting time value in format `yyyy-mm-dd`, got " + JSON.stringify(value));
  }
}
const DateTimeInputStringRegExp = /^\d+-\d{2}-\d{2}T\d{2}:\d{2}$/;
function assertDatetimeString(value) {
  if (typeof value !== "string") {
    throw new Error("Expecting time value in format `YYYY-MM-DDThh:mm`, got " + JSON.stringify(value));
  } else {
    const [date, time] = value.split("T");
    try {
      assertTimeString(time);
      assertDateString(date);
    } catch (error) {
      throw new Error("Expecting time value in format `YYYY-MM-DDThh:mm`, got " + JSON.stringify(value));
    }
  }
}
const WeekInputStringRegExp = /^\d{4}-W(?:[0-4]\d|5[0-2])$/;
function assertWeekInputString(value) {
  if (!(typeof value === "string" && value.match(WeekInputStringRegExp))) {
    throw new Error("Expecting week value in format `YYYY-W52`, got " + JSON.stringify(value));
  }
}
const MonthInputStringRegExp = /^\d{4}-\d{2}$/;
function assertMonthInputString(value) {
  if (!(typeof value === "string" && value.match(MonthInputStringRegExp))) {
    throw new Error("Expecting month value in format `YYYY-MM`, got " + JSON.stringify(value));
  }
}
const ColorRegExp = /^#(?:[0-9abcdef]{3,4}|[0-9abcdef]{6}|[0-9abcdef]{8})$/;
function assertColorString(value) {
  if (!(typeof value === "string" && value.match(ColorRegExp))) {
    throw new Error("Expecting color value in format `#RGB`, `#RGBA`, `#RRGGBB` or `#RRGGBBAA`, got " + JSON.stringify(value));
  }
}
export {
  ColorRegExp,
  DateInputStringRegExp,
  DateTimeInputStringRegExp,
  MonthInputStringRegExp,
  TimeInputStringRegExp,
  WeekInputStringRegExp,
  assertColorString,
  assertDateString,
  assertDatetimeString,
  assertMonthInputString,
  assertTimeString,
  assertWeekInputString
};
//# sourceMappingURL=ControlValues.js.map
